import { App } from 'vue';
import { VueSvgIconPlugin } from '@yzfe/vue3-svgicon';
import coreComponentRegistration from '@/core/config/core-component-registrations';
import errorHandlingConfig from '@/core/error-handling';
import dictionaryPlugin from '@/core/dictionary/dictionary.plugin';
import prohibitZoomDirective from '@/core/browser/prohibit-zoom.directive';
import onErrorDirective from '@/core/responsive/image/on-error.directive';
import autofocusDirective from '@/core/browser/autofocus.directive';
import clickOutside from '@/core/browser/click-outside.directive';
import delegateHtmlLinksDirective from '@/core/navigation/delegate-html-links.directive';
import resizeSelectDirective from '@/core/browser/resize-select.directive';

export default function coreConfig(app: App<Element>) {
    // 3rd party
    app.use(VueSvgIconPlugin, { tagName: 'vue-svgicon' });

    errorHandlingConfig(app);

    app.use(dictionaryPlugin);

    app.directive('prohibitZoom', prohibitZoomDirective);
    app.directive('onError', onErrorDirective);
    app.directive('autofocus', autofocusDirective);
    app.directive('delegateHtmlLinks', delegateHtmlLinksDirective);
    app.directive('clickOutside', clickOutside);
    app.directive('resizeSelect', resizeSelectDirective);

    // All core component registrations
    coreComponentRegistration(app);
}
